import { OnboardPreviousEmploymentDetails } from './OnboardPreviousEmploymentDetails';
import { OnboardProfessionalReferenceDetails } from './OnboardProfessionalReferenceDetails';

export class OnboardPrevEmploymentInfo {
  OnboardPrevEmploymentDetails: OnboardPreviousEmploymentDetails[];
  OnboardProfessionalRefDetails: OnboardProfessionalReferenceDetails[];
}

export class OnboardEmpPreviousEmploymentDtls {
  PriorExperienceYears: number;
  PriorExperienceMonths: number;
  onboardEmpPreviousEmploymentDtls: OnboardPreviousEmploymentDetails[]
}
